import { ReactElement, useState } from 'react';
import { NavigatorTab } from '@components/common/navigator-tab';
import { AddNewDataButton, Sort } from '@components/common';
import { overlayRemoveFadeAction } from '@components/common/sort';
import { SiteListTab } from '.';
import { SiteListSearch } from '@components/lms/siteListWrapper/components';
import { Outlet, useLocation } from 'react-router-dom';
import { useEndUserStore } from '@store/enduser';
import { useSiteAllDetailsStore } from '@store/siteAllDetailsStore';
import { SiteListFilters } from '@components/lms/siteListWrapper/components/siteListFilters';
import { SiteListFilterTag } from '@components/lms/siteListWrapper/components/siteListFilterTag';
import { useIsImpersonationLoginUser } from '../../../authGuard/hooks/useIsImpersonationLoginUser';
export const SiteListWrapper = (): ReactElement => {
	const {
		setIsEditing,
		setActiveNavTab,
		setIsFormEdit,
		setFormId,
		setFormRevalidate,
		setIsConvertingUpcomingToActive,
	} = useEndUserStore();
	const { clearSiteDetails } = useSiteAllDetailsStore();
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [openSort, setOpenSort] = useState<boolean>(false);
	const location = useLocation();
	const isImpersonationLoginUser = useIsImpersonationLoginUser();
	const handleClick = (): void => {
		setIsEditing(false);
		setFormId(null);
		setIsFormEdit(false);
		setActiveNavTab([0]);
		setFormRevalidate(false);
		setIsConvertingUpcomingToActive?.(false);
		clearSiteDetails();
	};
	return (
		<>
			<section className="tab-search-section">
				<div className="container">
					<NavigatorTab tabIndicator="inline" tabList={SiteListTab} selectedFilterChild={<SiteListFilterTag />}>
						<SiteListSearch
							setFilterOpen={() => setOpenFilter(!openFilter)}
							setSortOpen={() => setOpenSort(!openSort)}
							placeHolder="Search Name / Mobile / Site ID"
						/>
					</NavigatorTab>
					<Outlet key={location.pathname} />
				</div>
			</section>
			{openSort && <Sort setSortOpen={() => overlayRemoveFadeAction(() => setOpenSort(false))} />}
			{openFilter && (
				<SiteListFilters
					openFilters={openFilter}
					closeFilters={() => overlayRemoveFadeAction(() => setOpenFilter(false))}
				/>
			)}
			{!isImpersonationLoginUser && (
				<AddNewDataButton redirectUrl="/lms/add-new-site" labelName="Add new site" handleClick={handleClick} />
			)}
		</>
	);
};
